var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-page",
    {
      ref: "pageRef",
      attrs: {
        "view-slug": "home",
        "is-showing-web-awesome-release-notice": true,
      },
    },
    [
      _c("wa-page-header", {
        key: "header",
        attrs: { slot: "header" },
        slot: "header",
      }),
      _vm._v(" "),
      _c(
        "main",
        {
          staticStyle: {
            "--button-border-radius": "var(--card-border-radius)",
            "--card-margin-bottom": "2em",
            "--grid-gutter-x-width": "1rem",
            "--h4-font-size": "1.125em",
            "--h4-margin-bottom": "0.625em",
            "--headings-font-weight": "700",
          },
          attrs: { slot: "content", role: "main" },
          slot: "content",
        },
        [
          _c("hero"),
          _vm._v(" "),
          _c(
            "div",
            { ref: "StickyElementParent", staticClass: "container" },
            [
              _c("home-nav", {
                attrs: { "is-sticky-element-stuck": _vm.isStickyElementStuck },
              }),
              _vm._v(" "),
              _c("span", {
                ref: "StickyElementSentinel",
                staticClass: "sticky-element-sentinel",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("fa7-pro"),
              _vm._v(" "),
              !_vm.isSignedIn ? _c("start-free") : _vm._e(),
              _vm._v(" "),
              _c("pro-plus"),
              _vm._v(" "),
              _c("tech"),
              _vm._v(" "),
              _c("styling"),
              _vm._v(" "),
              _c("plan-compare"),
            ],
            1
          ),
          _vm._v(" "),
          _c("modal-web-awesome-announcement", {
            attrs: { "is-showing": _vm.isShowingWebAwesomeAnnouncementModal },
            on: {
              "close-modal": function ($event) {
                return _vm.hideWebAwesomeAnnouncementModal()
              },
            },
          }),
          _vm._v(" "),
          _c("open-source"),
          _vm._v(" "),
          _c("logos", { ref: "logos" }),
        ],
        1
      ),
      _vm._v(" "),
      _c("wa-page-footer", { attrs: { slot: "footer" }, slot: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }